<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header= "Información del Presupuesto">
          <b-form>
            <app-flujo-fondos-concepto
              label="Concepto"
              labelOption="Seleccione un concepto"
              :label-cols="labelCols"
              :nombre="flujoFondosConceptoNombre"
              :valido="flujoFondosConceptoValido"
              :lista="flujoFondosConceptosList"
              :msjInvalido="flujoFondosConceptoInvalidoMsj"
              @validate="validate"
              @updated="flujoFondosConceptoActualizado">
            </app-flujo-fondos-concepto>  

            <b-form-group
              label="Fecha Presupuestada"
              label-for="fechaPresupuestada"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaPresupuestada" 
                v-model="fechaPresupuestada" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Importe"
              label-for="importe"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="importe"
                v-model.trim="$v.importe.$model" 
                :state="importeValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeFeedback">
                {{ importeInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Observaciones"
              label-for="observaciones"
              :label-cols="labelCols"
              horizontal>
              <b-form-textarea
                id="observaciones"
                v-model="$v.observaciones.$model" 
                rows="3"
                max-rows="6"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import FlujoFondosConcepto from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { maxLength, decimal, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'flujoFondosPresupuesto/getField',
  mutationType: 'flujoFondosPresupuesto/updateField',
});

export default {
  name: 'FlujoFondosPresupuestoABM',
  components: {
    appFlujoFondosConcepto: FlujoFondosConcepto,
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      flujoFondosConceptoValido: null,
      flujoFondosConceptoInvalidoMsj: '',
      importeValido: null,
      importeInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',
      
      flujoFondosConceptos: [],
      flujoFondosConceptosList: [],

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'fechaPresupuestada',
      'flujoFondosConcepto',
      'flujoFondosConceptoNombre',
      'importe',
      'observaciones'
    ])
  },  
  created() {
    this.getDatosAdicionales();

    this.showSpinner();
    this.$store.dispatch('flujoFondosPresupuesto/inicializar')
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      let vm = this;
      
      vm.$store.dispatch('flujoFondosConceptos/getList')
        .then(() => {
          vm.flujoFondosConceptos = this.$store.getters['flujoFondosConceptos/list'];
          vm.flujoFondosConceptosList = this.$store.getters['flujoFondosConceptos/selectList'];
          return;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de conceptos'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'importe' || validarTodos) {
        this.importeValido = null;
        this.importeInvalidoMsj = this.displayErrorMonto (this.$v.importe.$error, 
          this.$v.importe.decimal, this.$v.importe.minValue); 
        
        if (this.importeInvalidoMsj.trim() != '') {
          this.importeValido = false;
        }
      }

      if (campo == "observaciones" || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones sólo pueden contener hasta 5000 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    displayErrorMonto( fieldError, fieldErrorDecimal, fieldErrorMinValue) {
      let errorMsj = '';
      if (fieldError) {
        if (fieldErrorDecimal) {
          errorMsj = 'El importe ingresado debe ser un valor numérico';
        } else if (fieldErrorMinValue) {
          errorMsj = 'El importe ingresado no es válido';
        }
      }
      return errorMsj;
    },
    save () {
      let save = true;

      let flujoFondosConceptoError = true;
      if (this.flujoFondosConcepto) {
        if (this.flujoFondosConcepto.id) {
          if (this.flujoFondosConcepto.id != 0) {
            flujoFondosConceptoError = false;
          }
        }
      }
      if (flujoFondosConceptoError) {
        save = Boolean(false);
        this.flujoFondosConceptoValido = false;
        this.flujoFondosConceptoInvalidoMsj = "Debe seleccionar el concepto correspondiente.";
      }

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('flujoFondosPresupuesto/save')
            .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      } 
    },
    goList() {
      this.$router.push({ name: "FlujoFondosPresupuestos" });
    },
    flujoFondosConceptoActualizado(nombre) {
      if (this.flujoFondosConceptoNombre != nombre) {
        this.flujoFondosConceptoNombre = nombre;
        
        let flujoFondosConcepto;
        if (this.flujoFondosConceptoNombre) {
          flujoFondosConcepto = this.getSelected(this.flujoFondosConceptos, this.flujoFondosConceptoNombre);
        }

        this.$store.dispatch('flujoFondosPresupuesto/setFlujoFondosConcepto', flujoFondosConcepto)
          .catch( error => this.showErrorMsj (error));

        if (this.flujoFondosConcepto.id != 0) {
          this.flujoFondosConceptoValido = null;
          this.flujoFondosConceptoInvalidoMsj = '';
        }
      }
    },
  },
  validations: {
    importe: { 
      decimal, 
      minValue: minValue(0) 
    },
    observaciones: {
      maxLength: maxLength(5000)
    },
  },   
}
</script>

<style>
</style>
